import { injectable, inject } from 'inversify';
import { ok, err } from '@/app/tracking/tracking-api';
import { ErrorHandlingScorm2004Client, ErrorHandlingScorm2004ClientSymbol } from '@/app/tracking/scorm/2004/client';
import { BookmarkDataStore, BookmarkErrorCode, Bookmark } from '../common';

@injectable()
export class Scorm2004BookmarkDataStore implements BookmarkDataStore {

  constructor(
    @inject(ErrorHandlingScorm2004ClientSymbol)
    private readonly client: ErrorHandlingScorm2004Client) {
  }

  public async get() {
    const result = await this.client.getValue('cmi.location');
    if (!result.success) {
      return err({
        code: 'query-error' as BookmarkErrorCode,
        details: result.error
      });
    }

    return ok({ sectionId: result.value ? result.value.trim() : '' });
  }

  public async update(bookmark: Bookmark) {

    this.client.setValue('cmi.location', bookmark.sectionId);

    return ok(true as true);
  }
}
